module.exports = __webpack_public_path__ + "static/media/education.8a50c873.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/education.jpeg
// module id = 392
// module chunks = 0